<template>
  <div class="container-chart">
    <apexchart
      ref="chart"
      height="300"
      type="line"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="controls-chart">
      <button class="btn-change-data left" @click="$emit('change-data', -1)">
        <i class="material-icons">arrow_left</i>
      </button>
      <button class="btn-change-data right" @click="$emit('change-data', 1)">
        <i class="material-icons">arrow_right</i>
      </button>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    customOptions: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    chartOptions() {
      let options = {
        chart: {
          id: 'vuechart-line',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        stroke: {
          curve: 'smooth',
        },
      };
      for (const [key, value] of Object.entries(this.customOptions)) {
        options[key] = value;
      }
      return options;
    },
  },
  methods: {
    updateData(newData) {
      this.$refs.chart.updateSeries(newData);
    },
  },
};
</script>

<style scope>
.container-chart {
  position: relative;
}

.controls-chart {
  position: absolute;
  bottom: -1rem;

  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.btn-change-data {
  width: 3.8rem;
  height: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;
  background-color: rgb(119, 93, 208);
  border: none;
}

.btn-change-data.left {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}

.btn-change-data.right {
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}
</style>
